













import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { City } from '../../api/location/types';
import * as locationService from '@/services/location/index';

@Component
export default class CitySelectController extends Vue {
  @Prop({default: '', type: String}) private value!: City;
  private ckey = 0;

  private loadingSentinel = {};
  private emptySentinel = {};

  private get city() {
    return this.isLoadingLocation ? this.loadingSentinel : (this.$store.state.location.cityContext || this.emptySentinel);
  }

  private get options() {
    return this.$store.state.location.citiesOptions;
  }

  private get dataSelectedAttr() {
    return (this.city === this.loadingSentinel || this.city === this.emptySentinel) ? '' : this.city;
  }
  

  private get isLoadingLocation() {
    return this.$store.getters['location/isLoading'];
  }

  private get canGetSelected() {
    return this.$store.getters['location/canSelectCities'];
  }

  private get isDisabled() {
    return !!this.$attrs.disabled || this.isLoadingLocation || !this.canGetSelected;
  }

  @Watch('value', { immediate: true })
  private changedValue(city: City) {
    if (city !== this.loadingSentinel) {
      locationService.selectCity(city === this.emptySentinel ? '' : city);
    }
  }

  @Watch('city')
  private cityChanged(city: City) {
    this.ckey += 1;
    if (city !== this.loadingSentinel) {
      this.$emit('input', city === this.emptySentinel ? '' : city);
    }
  }

  @Watch('options')
  private optionsChanged() {
    this.ckey += 1;
  }

}
